//import {IMASWindow} from "../components/common";

export interface NoobookHeader
{
    'Content-Type'?: string | null;
    Authorization?: string | null;
    'X-Authorization'?: string | null;
    AccessAgent?: string | null;
}

export function genNoobookHeader(authToken?:string | null, refreshToken?:string | null, contentType?:string | null, accessAgent?:string | null):NoobookHeader
{
    var header:NoobookHeader = {};
    if(authToken)
    {
        //header = Object.assign(header, {"Authorization":`Bearer ${authToken}`})
        header = {...header, "Authorization":`Bearer ${authToken}`};
    }
    if(refreshToken)
    {
        //header = Object.assign(header, {"X-Authorization":'Bearer ' + refreshToken})
        header = {...header, "X-Authorization":`Bearer ${refreshToken}`};
    }
    if(contentType)
    {
        //header = Object.assign(header, {"Content-Type":contentType})
        header = {...header, "Content-Type":contentType};
    }
    if(accessAgent)
    {
        //header = Object.assign(header, {"AccessAgent":accessAgent})
        header = {...header, "AccessAgent":accessAgent};
    }
    //IMASWindow.alert('genNoobookHeader :' + header["Content-Type"]);
    return header;
}
